








































import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import sanitizeHtml from 'sanitize-html'
import { defaultSanitizeHtmlOptions } from '~/constants/sanitization'
import { defineComponent } from '@nuxtjs/composition-api'
import { mapGetters } from 'vuex'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { vue3Model } from '~/utils/nuxt3-migration'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: { type: String, default: '', required: true },
    disabled: { type: Boolean, default: false, required: false },
    shiftEnter: { type: Boolean, default: false, required: false },
    placeholder: { type: String, default: '', required: false },
    characterLimit: { type: Number, default: 0, required: false },
    inputClasses: { type: String, default: '', required: false }
  },
  data() {
    return {
      noteLines: [],
      currentCharLength: 0
    }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    }),
    showCharLimitWarning() {
      // start showing character warning when the text is close to getting over the limit
      return (
        this.characterLimit > 0 &&
        this.currentCharLength >=
          this.characterLimit - this.characterLimit * 0.05
      )
    },
    icons() {
      return {
        check: faCheckCircle,
        times: faTimesCircle
      }
    },
    overCharLimit() {
      if (this.characterLimit > 0) {
        return this.currentCharLength > this.characterLimit
      }
      return false
    },
    charlimitTooltipText() {
      if (this.showCharLimitWarning) {
        if (this.overCharLimit) {
          return this.$t(
            'your message is over %s characters long, please remove the extra characters in order to be able to send it'
          ).replace('%s', this.characterLimit)
        } else {
          return this.$t(
            'the message character limit is %s characters'
          ).replace('%s', this.characterLimit)
        }
      }
      return ''
    }
  },
  watch: {
    modelValue(newValue) {
      if (newValue === '') {
        this.$refs.lines.textContent = ''
        this.currentCharLength = 0
      }
    },
    overCharLimit(newValue) {
      this.$emit('over-character-limit', newValue)
    }
  },
  methods: {
    onInput() {
      const lines = this.$refs.lines

      let stringToEmit = ''

      if (lines.childNodes[0]) {
        if (lines.childNodes[0].nodeType === Node.TEXT_NODE) {
          stringToEmit = lines.childNodes[0].textContent
        }
      }

      for (let i = 1; i < lines.childNodes.length; i++) {
        if (lines.childNodes[i].tagName === 'BR') {
          stringToEmit += '\n'
        } else {
          stringToEmit += lines.childNodes[i].textContent
        }
      }

      let checkfornull = stringToEmit
      checkfornull = checkfornull.trim()
      checkfornull = checkfornull.replace(/<br>/g, '')

      if (checkfornull === '') {
        stringToEmit = ''
      }

      if (this.characterLimit > 0) {
        this.currentCharLength = stringToEmit.length
      }

      this.$emit('update:modelValue', stringToEmit)
    },
    focusInput() {
      this.$refs.lines.focus()
    },
    moveCursorToEnd(contentEditableElement) {
      let range, selection
      if (document.createRange) {
        // Firefox, Chrome, Opera, Safari, IE 9+
        range = document.createRange()
        range.selectNodeContents(contentEditableElement)
        range.collapse(false)
        selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
      }
    },
    handlePaste(e) {
      e.preventDefault()
      const lines = this.$refs.lines
      let clipboardText = ''
      if (typeof e.clipboardData === 'undefined') {
        clipboardText = window.clipboardData.getData('text')
      } else {
        clipboardText = e.clipboardData.getData('text')
      }

      const range =
        this.adjustRange(window.getSelection().getRangeAt(0)) || null

      if (lines.childNodes.length) {
        const node = document.createElement('span')
        const textNode = document.createTextNode(
          sanitizeHtml(clipboardText, defaultSanitizeHtmlOptions)
        )
        node.appendChild(textNode)

        if (range) {
          range.deleteContents()
          if (
            range.endContainer.nodeType === 3 ||
            range.startContainer.nodeType === 3
          ) {
            range.insertNode(textNode)
          } else {
            range.insertNode(node)
          }
          range.collapse(false)
          window.getSelection().removeAllRanges()
          window.getSelection().addRange(range)
        } else {
          this.$refs.lines.appendChild(node)
          this.moveCursorToEnd(this.$refs.lines)
        }
      } else {
        // it's empty
        this.$refs.lines.textContent = sanitizeHtml(
          clipboardText,
          defaultSanitizeHtmlOptions
        )
        this.moveCursorToEnd(this.$refs.lines)
      }

      this.onInput()
    },
    adjustRange(range) {
      range = range.cloneRange()
      if (range.startContainer.nodeType !== 3) {
        const nodeAfterStart =
          range.startContainer.childNodes[range.startOffset]
        if (nodeAfterStart && nodeAfterStart.nodeType === 3) {
          range.setStart(nodeAfterStart, 0)
        }
      }
      if (range.endContainer.nodeType !== 3 && range.endOffset >= 1) {
        const nodeBeforeEnd = range.endContainer.childNodes[range.endOffset - 1]
        if (nodeBeforeEnd && nodeBeforeEnd.nodeType === 3) {
          range.setEnd(nodeBeforeEnd, nodeBeforeEnd.data.length)
        }
      }
      return range
    },
    keyDown(event) {
      if (event.keyCode === 13 && this.shiftEnter && this.isPc) {
        if (!event.shiftKey) {
          event.preventDefault()
          this.$emit('submit')
        }
      }
    },
    onBlur() {
      if (this.modelValue.length === 0) {
        this.$emit('blurred-and-empty')
      }
    }
  }
})
